import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { CourseEntity, LanguageEntity, UniversityEntity } from '../types';

export interface VseApplFormCourseSelectionProps extends Pick<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  data: CourseEntity[],
  selected?: CourseEntity,
  onCourseFiltering: () => void,
  onCourseSelected: (selected: CourseEntity) => void,
  getUniversity: (id: number) => UniversityEntity | undefined,
  getLanguageEntity: (code: string) => LanguageEntity | undefined,
}

export function VseApplFormCourseSelection(props: VseApplFormCourseSelectionProps) {

  function renderCourse(c: CourseEntity, i: number) {
    const isSelected = props.selected ?
      c.universityID === props.selected.universityID &&
      c.seasonID === props.selected.seasonID &&
      c.termCode === props.selected.termCode &&
      c.courseCode === props.selected.courseCode
      : false;
    const univ = props.getUniversity(c.universityID);
    const lang = props.getLanguageEntity(c.language);
    /*
    const termStart = c.universityTerm ? (new Intl.DateTimeFormat('en-GB')).format(c.universityTerm.startDate) : undefined;
    const termEnd = c.universityTerm ? (new Intl.DateTimeFormat('en-GB')).format(c.universityTerm.endDate) : undefined;
    const termPerid = c.universityTerm ? `${termStart} to ${termEnd}` : undefined;
    */
    return (
      <TableRow key={i} >
        <TableCell component="th" scope="row" padding="checkbox">
          <Checkbox checked={isSelected} onClick={
            () => props.onCourseSelected(c)
          } />
        </TableCell>
        <TableCell>{univ?.universityName}</TableCell>
        <TableCell>{c.courseCode}</TableCell>
        <TableCell>{c.courseTitle}</TableCell>
        <TableCell>{new Intl.NumberFormat('en-GB', { minimumFractionDigits: 1 }).format(c.units)}</TableCell>
        <TableCell>{lang?.description}</TableCell>
      </TableRow>
    );
  }

  function renderCourses() {
    if (props.data && props.data.length > 0) {
      return props.data.map((c, i) => {
        return renderCourse(c, i);
      });
    }
    return undefined;
  }

  const [init, setInit] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!init) {
      props.onCourseFiltering();
      setInit(true);
    }
  })

  return (
    <div className={props.className}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Select</TableCell>
            <TableCell>Course Offering University</TableCell>
            <TableCell>Course Code</TableCell>
            <TableCell>Course Title</TableCell>
            <TableCell>No. of Credits</TableCell>
            <TableCell>Language of Instruction</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {renderCourses()}
        </TableBody>
      </Table>
    </div>
  );
}
